var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.82,
    height: 15.98,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tooth -") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 2.188547,
    width: 2.151263,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m5.16,13.64a5.93,5.93 0 0 1 -0.44,1.65a1.16,1.16 0 0 1 -1.42,0.63c-0.62,-0.31 -0.59,-1.18 -0.55,-1.88c0.11,-2.33 -0.89,-2.82 -1.7,-5s-1.48,-4.63 -0.7,-6.83a2.93,2.93 0 0 1 2,-2a8,8 0 0 1 5,0.58c0.2,0.1 0.55,-0.13 0.73,-0.21a4.11,4.11 0 0 1 0.92,-0.33a3.15,3.15 0 0 1 2.29,0.28a3.5,3.5 0 0 1 1.23,1.68c0.77,2.2 0.11,4.63 -0.7,6.82s-1.82,2.68 -1.7,5c0,0.7 0.07,1.57 -0.56,1.88a1.17,1.17 0 0 1 -1.42,-0.63a8.55,8.55 0 0 1 -0.44,-1.65a2.7,2.7 0 0 0 -1.45,-2.05a8,8 0 0 0 -1.09,2.06z",
    className: "cls-1",
    id: "Path_163"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/tooth.0e3aad801f7682cd727a86d83b952a74.svg";
export { ForwardRef as ReactComponent };